export default "<h1>\r\n  <mat-icon class=\"icon\">{{icon}}</mat-icon>\r\n  {{title}}\r\n</h1>\r\n"